import { useEffect } from "react";

function isMonitoringEnabled() {
  return (process.env.REACT_APP_MONITORING_ENABLED || "").toLowerCase() === "true";
}

function getMonitoringEndpoint() {
  const backendUrl = process.env.REACT_APP_BACKEND_URL || "";
  return `${backendUrl}/api/monitoring/frontend`;
}

function serializeErrorEvent(event) {
  return {
    kind: "error",
    message: event.message || "Unknown frontend error",
    route: `${window.location.pathname}${window.location.search}`,
    user_agent: navigator.userAgent.slice(0, 160),
    occurred_at: new Date().toISOString(),
    context: {
      source: "window.error",
      filename: event.filename || undefined,
      line: typeof event.lineno === "number" ? event.lineno : undefined,
      column: typeof event.colno === "number" ? event.colno : undefined,
    },
  };
}

function serializeRejectionEvent(event) {
  const reason =
    typeof event.reason === "string"
      ? event.reason
      : event.reason?.message || "Unhandled promise rejection";

  return {
    kind: "unhandledrejection",
    message: reason,
    route: `${window.location.pathname}${window.location.search}`,
    user_agent: navigator.userAgent.slice(0, 160),
    occurred_at: new Date().toISOString(),
    context: {
      source: "window.unhandledrejection",
    },
  };
}

function sendEvent(payload) {
  const body = JSON.stringify(payload);
  const endpoint = getMonitoringEndpoint();

  if (navigator.sendBeacon) {
    const blob = new Blob([body], { type: "application/json" });
    navigator.sendBeacon(endpoint, blob);
    return;
  }

  fetch(endpoint, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body,
    keepalive: true,
  }).catch(() => {});
}

export default function MonitoringBridge() {
  useEffect(() => {
    if (!isMonitoringEnabled()) {
      return undefined;
    }

    const handleError = (event) => {
      sendEvent(serializeErrorEvent(event));
    };

    const handleUnhandledRejection = (event) => {
      sendEvent(serializeRejectionEvent(event));
    };

    window.addEventListener("error", handleError);
    window.addEventListener("unhandledrejection", handleUnhandledRejection);

    return () => {
      window.removeEventListener("error", handleError);
      window.removeEventListener("unhandledrejection", handleUnhandledRejection);
    };
  }, []);

  return null;
}
